import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type privateBillingDetailsForm_Billing_CustomerDetailsFragment$key } from "@relay/privateBillingDetailsForm_Billing_CustomerDetailsFragment.graphql";
import { PRIVATE_BILLING_DETAILS_FRAGMENT } from "./private-billing-details-form.graphql";
import { type PrivateBillingDetailsFormProps } from "./private-billing-details-form.interface";
import { formatDateTime } from "../../../../components/datetime-display/datetime-display.util";
import { TextDisplayField } from "../../../../components/text-display-field";
import { H2Span } from "../../../../themes/font-tags";

export const PrivateBillingDetailsForm = ({
	privateBillingDetailsFragmentRef,
}: PrivateBillingDetailsFormProps) => {
	const { t } = useTranslation("common");
	const privateBillingDetails =
		useFragment<privateBillingDetailsForm_Billing_CustomerDetailsFragment$key>(
			PRIVATE_BILLING_DETAILS_FRAGMENT,
			privateBillingDetailsFragmentRef,
		);

	return (
		<div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.firstName")}
					value={privateBillingDetails.firstName}
				/>
				<TextDisplayField
					label={t("billing.lastName")}
					value={privateBillingDetails.lastName}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.street")}
					value={privateBillingDetails.street}
				/>
				<TextDisplayField
					label={t("billing.houseNumber")}
					value={privateBillingDetails.houseNumber}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField label={t("billing.city")} value={privateBillingDetails.city} />
				<TextDisplayField
					label={t("billing.postalCode")}
					value={privateBillingDetails.postalCode}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.country")}
					value={privateBillingDetails.country}
				/>
				<TextDisplayField
					label={t("billing.salutation")}
					value={privateBillingDetails.salutation}
				/>
			</div>
			<div className="formgrid grid">
				<TextDisplayField
					label={t("billing.invoiceEmail")}
					value={privateBillingDetails.invoiceEmail}
				/>
				<TextDisplayField
					label={t("billing.birthday")}
					value={formatDateTime(privateBillingDetails.data.dateOfBirth ?? "")}
				/>
			</div>
			{privateBillingDetails.data.invoiceAddress && (
				<div>
					<H2Span>{t("billing.invoiceAddress")}</H2Span>
					<div className="formgrid grid">
						<TextDisplayField
							label={t("billing.firstName")}
							value={privateBillingDetails.data.invoiceAddress.firstName}
						/>
						<TextDisplayField
							label={t("billing.lastName")}
							value={privateBillingDetails.data.invoiceAddress.lastName}
						/>
					</div>
					<div className="formgrid grid">
						<TextDisplayField
							label={t("billing.street")}
							value={privateBillingDetails.data.invoiceAddress.street}
						/>
						<TextDisplayField
							label={t("billing.houseNumber")}
							value={privateBillingDetails.data.invoiceAddress.houseNumber}
						/>
					</div>
					<div className="formgrid grid">
						<TextDisplayField
							label={t("billing.city")}
							value={privateBillingDetails.data.invoiceAddress.city}
						/>
						<TextDisplayField
							label={t("billing.postalCode")}
							value={privateBillingDetails.data.invoiceAddress.postalCode}
						/>
					</div>
					<div className="formgrid grid">
						<TextDisplayField
							label={t("billing.country")}
							value={privateBillingDetails.data.invoiceAddress.country}
						/>
						<TextDisplayField
							label={t("billing.companyName")}
							value={privateBillingDetails.data.invoiceAddress.companyName}
						/>
					</div>
					<div className="formgrid grid">
						<TextDisplayField
							label={t("billing.companyDetails")}
							value={
								privateBillingDetails.data.invoiceAddress.companyDetails ||
								undefined
							}
						/>
					</div>
				</div>
			)}
		</div>
	);
};
